import { memo } from 'react';
import type { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';

import resets from '../../../_resets.module.css';
import classes from './Button_ellipse.module.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
  classes?: {
    root?: string;
  };
  text?:string;
  link?;
}
/* @figmaId 247:10 */
export const Button_ellipse: FC<Props> = memo(function Button_ellipse(props = {}) {
  const { t, i18n } = useTranslation();

  const location = useLocation(); // 現在のロケーションを取得
  const langCode = i18n.language; // i18nから現在の言語を取得
  
  // リンクが空の場合はボタンを非表示
  if (!props.link) {
    return null;
  }
  
  // ハッシュリンク（#で始まる）の場合は、言語コードを付けずにそのまま使用
  const linkPath = props.link.startsWith('#') 
    ? `/${langCode}${props.link}`
    : `/${langCode}/${props.link}`;
  
  return (
    <Link to={linkPath} className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.root}`}>
      <div className={classes.text}>{props.text ||  t('common:button.details')}</div>
    </Link>
  );
});


